import { Box, Typography } from "@mui/material";
import mockup from "./assets/mockup-page.png";

const MemorialPage = () => {
  return (
    <Box
      id="stream-page"
      sx={{
        p: 6,
        height: "1056px",
        width: "816px",
        overflow: "hidden",
        transform: "scale(0.9)",
        transformOrigin: "top left",
      }}
    >
      {/* Header */}
      <Box sx={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textTransform: "uppercase" }}
        >
          SAMPLE PERSONALISED MEMORIAL PAGE
        </Typography>
        <Typography variant="body1" sx={{ mt: 2, lineHeight: 1.7 }}>
          A personalised memorial page is a dedicated online space created to
          honour and celebrate the life of your loved one.It can be shared with
          those who are unable to attend in person and remains available as a
          lasting digital tribute that you may update and customise at any time.
        </Typography>
      </Box>
      <Box
        component="img"
        src={mockup}
        alt="proposal background"
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block",
        }}
      />
    </Box>
  );
};

export default MemorialPage;
